import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function AuthSuccess() {
  const { refreshUser } = useAuth();

  useEffect(() => {
    // Extract token from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const error = urlParams.get('error');

    if (error) {
      // Redirect to landing with error
      console.error('[AUTH] Authentication error:', error);
      window.location.href = '/';
      return;
    }

    if (!token) {
      // No token, redirect to landing
      console.error('[AUTH] No token in URL');
      window.location.href = '/';
      return;
    }

    // Store token in localStorage
    localStorage.setItem('auth_token', token);
    console.log('[AUTH] Token stored successfully');

    // Trigger auth context to fetch user
    refreshUser();

    // Clear URL and redirect to home (will show app now that we're authenticated)
    window.history.replaceState({}, document.title, '/');
  }, [refreshUser]);

  return (
    <div className="h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-lg font-medium text-foreground">Completing sign in...</p>
      </div>
    </div>
  );
}
